import * as React from 'react';
import { useGetCurrentClient } from '@frontend/app/hooks';
import { PostInsights } from '@frontend/gql/social/graphql';
import { LoadSpinner } from '@components';
import { usePostsData } from '../Social/Analytics/hooks/usePostsData';
import { useFilterFormData } from '../Social/Analytics/components/filters-form/hooks/useFilterFormData';
import { DateType, QueryVariables } from '../Social/Analytics/types';
import { useAnalyticsParams } from '../Social/Analytics/hooks/useAnalyticsParams';
import PostInsightsCard from '../Social/Analytics/components/post-insights-card';
import { NewSocialPostAssignment } from './components/newSocialPostAssignment';
import { useApplication } from '../Shared/context/applicationContext';

const { useState } = React;
export const NewMemberSocialPostList: React.FunctionComponent = () => {
  const [postToAssign, setPostToAssign] = useState<PostInsights | null>(null);
  const { projects, groups, isFetchingProjects, isFetchingGroups } = useFilterFormData();

  const { memberId } = useApplication();
  const DEFAULT_VARIABLES: Omit<QueryVariables, 'clientId'> = {
    dateType: 'allTime' as DateType,
    postTypes: [],
    includeEstimates: true,
    networks: [],
    projectIds: [],
    groupIds: [],
    memberIds: [memberId],
    segments: [],
    postDateIntervalEnabled: false,
  };

  const { client } = useGetCurrentClient();
  const clientCreatedDate = client?.createdDate;
  const clientId = client?.id;
  const { queryVariables } = useAnalyticsParams({
    clientId,
    defaultVariables: DEFAULT_VARIABLES,
    clientCreatedDate,
  });
  const {
      data: postsData,
      fetchingPosts: fetching,
  } = usePostsData({
      clientId,
      tab: 'posts',
      queryVariables,
      projects,
      groups,
  });
  // Handler for post click
  const handlePostClick = (post: PostInsights) => {
    setPostToAssign(post);
  };
  if (isFetchingProjects || isFetchingGroups || fetching) {
    return (
      <div className="flex justify-center items-center h-full w-full">
        <LoadSpinner centered />
      </div>
    );
  }
  if (!postsData?.client?.socialAnalytics?.posts?.results) {
    return null;
  }
  if (postToAssign) {
    return (
      <NewSocialPostAssignment
        projects={projects}
        post={postToAssign}
        groups={groups}
      />
    );
  }
  return (
    <div className="h-[calc(100vh-116px)] w-full overflow-auto">
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 4xl:grid-cols-5 5xl:grid-cols-6 6xl:grid-cols-7 gap-4 p-4">
        {postsData.client.socialAnalytics.posts.results.map((post) => (
          <button
            key={post.entityId}
            onClick={() => handlePostClick(post)}
            className="w-full text-left cursor-pointer appearance-none bg-transparent border-0 p-0 m-0"
            aria-label={`View details for post ${post.entityId}`}
          >
            <PostInsightsCard
              post={post}
              isSelected={false}
              removeSelectionCheckbox
            />
          </button>
        ))}
      </div>
    </div>
  );
};
